import { render } from "./VDropDown.vue?vue&type=template&id=08890977&scoped=true"
import script from "./VDropDown.vue?vue&type=script&lang=js"
export * from "./VDropDown.vue?vue&type=script&lang=js"

import "./VDropDown.vue?vue&type=style&index=0&id=08890977&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08890977"]])

export default __exports__